import { setConfig } from '@common/config';
import { initI18n } from '@common/i18n';
import { setPurpleZoneParams } from '@common/purpleZoneCookie';
import '@css/App.scss';
import { type IConfig } from '@interface/ICommon';
import { queryClient } from '@network/remote';
import { store } from '@store/index';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

export const AppInit = (selecter: string, config: IConfig, MainApp: () => JSX.Element, mainLoader: any) => {
    const container = document.querySelector(selecter);
    if (!container) throw new Error('No container exists');
    setConfig(config);
    initI18n(config.wstatic);
    setPurpleZoneParams();

    const router = createBrowserRouter(createRoutesFromElements(<Route path="*" element={<MainApp />} loader={mainLoader} />));
    createRoot(container).render(
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <RouterProvider router={router} />
            </Provider>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
};
